import tonyRive from '@assets/rives/Tony.riv?url';
import vipRive from '@assets/rives/VIP_Tony.riv?url';

import backgroundFactoryChildrenJpg from '/img/bg/factory_Childrens_Goods.jpg';
import backgroundFactoryChildrenWebp from '/img/bg/factory_Childrens_Goods.webp';
import newYearBackgroundFactoryChildrenPng from '/img/bg/factory_Childrens_Goods-new_year.png';
import newYearBackgroundFactoryChildrenWebp from '/img/bg/factory_Childrens_Goods-new_year.webp';
import backgroundFactoryElectronicsJpg from '/img/bg/factory_Electronics.jpg';
import backgroundFactoryElectronicsWebp from '/img/bg/factory_Electronics.webp';
import newYearBackgroundFactoryElectronicsPng from '/img/bg/factory_Electronics-new_year.png';
import newYearBackgroundFactoryElectronicsWebp from '/img/bg/factory_Electronics-new_year.webp';
import backgroundFactoryFurnitureJpg from '/img/bg/factory_Furniture.jpg';
import backgroundFactoryFurnitureWebp from '/img/bg/factory_Furniture.webp';
import newYearBackgroundFactoryFurniturePng from '/img/bg/factory_Furniture-new_year.png';
import newYearBackgroundFactoryFurnitureWebp from '/img/bg/factory_Furniture-new_year.webp';
import backgroundFactoryGarmentJpg from '/img/bg/factory_Garment.jpg';
import backgroundFactoryGarmentWebp from '/img/bg/factory_Garment.webp';
import newYearBackgroundFactoryGarmentPng from '/img/bg/factory_Garment-new_year.png';
import newYearBackgroundFactoryGarmentWebp from '/img/bg/factory_Garment-new_year.webp';
import backgroundFactoryHomewareJpg from '/img/bg/factory_Homeware.jpg';
import backgroundFactoryHomewareWebp from '/img/bg/factory_Homeware.webp';
import newYearBackgroundFactoryHomewarePng from '/img/bg/factory_Homeware-new_year.png';
import newYearBackgroundFactoryHomewareWebp from '/img/bg/factory_Homeware-new_year.webp';
import backgroundFactoryMechanicJpg from '/img/bg/factory_Mechanic.jpg';
import backgroundFactoryMechanicWebp from '/img/bg/factory_Mechanic.webp';
import backgroundFactoryMusicJpg from '/img/bg/factory_Music.jpg';
import backgroundFactoryMusicWebp from '/img/bg/factory_Music.webp';
import newYearBackgroundFactoryMusicPng from '/img/bg/factory_Music-new_year.png';
import newYearBackgroundFactoryMusicWebp from '/img/bg/factory_Music-new_year.webp';
import backgroundFactoryPrintedJpg from '/img/bg/factory_Printed.jpg';
import backgroundFactoryPrintedWebp from '/img/bg/factory_Printed.webp';
import newYearBackgroundFactoryPrintedPng from '/img/bg/factory_Printed-new_year.png';
import newYearBackgroundFactoryPrintedWebp from '/img/bg/factory_Printed-new_year.webp';
import backgroundFactoryToolmakingJpg from '/img/bg/factory_Toolmaking.jpg';
import backgroundFactoryToolmakingWebp from '/img/bg/factory_Toolmaking.webp';
import newYearBackgroundFactoryToolmakingPng from '/img/bg/factory_Toolmaking-new_year.png';
import newYearBackgroundFactoryToolmakingWebp from '/img/bg/factory_Toolmaking-new_year.webp';
import backgroundGoodsStockPng from '/img/bg/hero-bg-storage-goods.png';
import backgroundGoodsStockWebp from '/img/bg/hero-bg-storage-goods.webp';
import helloweenBackgroundGoodsStockPng from '/img/bg/hero-bg-storage-goods-helloween.png';
import helloweenBackgroundGoodsStockWebp from '/img/bg/hero-bg-storage-goods-helloween.webp';
import newYearBackgroundGoodsStockPng from '/img/bg/hero-bg-storage-goods-new_year.png';
import newYearBackgroundGoodsStockWebp from '/img/bg/hero-bg-storage-goods-new_year.webp';
import backgroundMaterialStockPng from '/img/bg/hero-bg-storage-material.png';
import backgroundMaterialStockWebp from '/img/bg/hero-bg-storage-material.webp';
import helloweenBackgroundMaterialStockPng from '/img/bg/hero-bg-storage-material-helloween.png';
import helloweenBackgroundMaterialStockWebp from '/img/bg/hero-bg-storage-material-helloween.webp';
import newYearBackgroundMaterialStockPng from '/img/bg/hero-bg-storage-material-new_year.png';
import newYearBackgroundMaterialStockWebp from '/img/bg/hero-bg-storage-material-new_year.webp';
import backgroundResourceStockPng from '/img/bg/hero-bg-storage-resource.png';
import backgroundResourceStockWebp from '/img/bg/hero-bg-storage-resource.webp';
import helloweenBackgroundResourceStockPng from '/img/bg/hero-bg-storage-resource-helloween.png';
import helloweenBackgroundResourceStockWebp from '/img/bg/hero-bg-storage-resource-helloween.webp';
import newYearBackgroundResourceStockPng from '/img/bg/hero-bg-storage-resource-new_year.png';
import newYearBackgroundResourceStockWebp from '/img/bg/hero-bg-storage-resource-new_year.webp';
import backgroundHomePng from '/img/bg/main-page-2.png';
import backgroundHomeWebp from '/img/bg/main-page-2.webp';
import helloweenBackgroundHomePng from '/img/bg/main-page-2-helloween.png';
import helloweenBackgroundHomeWebp from '/img/bg/main-page-2-helloween.webp';
import newYearBackgroundHomePng from '/img/bg/main-page-2-new_year.png';
import newYearBackgroundHomeWebp from '/img/bg/main-page-2-new_year.webp';
import materialPng from '/img/bg/materials-bg.png';
import materialWebp from '/img/bg/materials-bg.webp';
import helloweenMaterialPng from '/img/bg/materials-bg-helloween.png';
import helloweenMaterialWebp from '/img/bg/materials-bg-helloween.webp';
import newYearMaterialPng from '/img/bg/materials-bg-new_year.png';
import newYearMaterialWebp from '/img/bg/materials-bg-new_year.webp';
import backgroundSandJpg from '/img/bg/mine-bg-bulk.jpg';
import backgroundSandWebp from '/img/bg/mine-bg-bulk.webp';
import helloweenBackgroundSandPng from '/img/bg/mine-bg-bulk-helloween.png';
import helloweenBackgroundSandWebp from '/img/bg/mine-bg-bulk-helloween.webp';
import newYearBackgroundSandPng from '/img/bg/mine-bg-bulk-new_year.png';
import newYearBackgroundSandWebp from '/img/bg/mine-bg-bulk-new_year.webp';
import backgroundCottonJpg from '/img/bg/mine-bg-cotton.jpg';
import backgroundCottonWebp from '/img/bg/mine-bg-cotton.webp';
import helloweenBackgroundCottonPng from '/img/bg/mine-bg-cotton-helloween.png';
import helloweenBackgroundCottonWebp from '/img/bg/mine-bg-cotton-helloween.webp';
import newYearBackgroundCottonPng from '/img/bg/mine-bg-cotton-new_year.png';
import newYearBackgroundCottonWebp from '/img/bg/mine-bg-cotton-new_year.webp';
import backgroundIronJpg from '/img/bg/mine-bg-iron.jpg';
import backgroundIronWebp from '/img/bg/mine-bg-iron.webp';
import helloweenBackgroundIronPng from '/img/bg/mine-bg-iron-helloween.png';
import helloweenBackgroundIronWebp from '/img/bg/mine-bg-iron-helloween.webp';
import newYearBackgroundIronPng from '/img/bg/mine-bg-iron-new_year.png';
import newYearBackgroundIronWebp from '/img/bg/mine-bg-iron-new_year.webp';
import backgroundOilJpg from '/img/bg/mine-bg-oil.jpg';
import backgroundOilWebp from '/img/bg/mine-bg-oil.webp';
import helloweenBackgroundOilPng from '/img/bg/mine-bg-oil-helloween.png';
import helloweenBackgroundOilWebp from '/img/bg/mine-bg-oil-helloween.webp';
import newYearBackgroundOilPng from '/img/bg/mine-bg-oil-new_year.png';
import newYearBackgroundOilWebp from '/img/bg/mine-bg-oil-new_year.webp';
import backgroundPreciousJpg from '/img/bg/mine-bg-precious.jpg';
import backgroundPreciousWebp from '/img/bg/mine-bg-precious.webp';
import helloweenBackgroundPreciousPng from '/img/bg/mine-bg-precious-helloween.png';
import helloweenBackgroundPreciousWebp from '/img/bg/mine-bg-precious-helloween.webp';
import newYearBackgroundPreciousPng from '/img/bg/mine-bg-precious-new_year.png';
import newYearBackgroundPreciousWebp from '/img/bg/mine-bg-precious-new_year.webp';
import backgroundWoodJpg from '/img/bg/mine-bg-wood.jpg';
import backgroundWoodWebp from '/img/bg/mine-bg-wood.webp';
import helloweenBackgroundWoodPng from '/img/bg/mine-bg-wood-helloween.png';
import helloweenBackgroundWoodWebp from '/img/bg/mine-bg-wood-helloween.webp';
import newYearBackgroundWoodPng from '/img/bg/mine-bg-wood-new_year.png';
import newYearBackgroundWoodWebp from '/img/bg/mine-bg-wood-new_year.webp';
import resourcePng from '/img/bg/resource-page.png';
import resourceWebp from '/img/bg/resource-page.webp';
import helloweenResourcePng from '/img/bg/resource-page-helloween.png';
import helloweenResourceWebp from '/img/bg/resource-page-helloween.webp';
import newYearResourcePng from '/img/bg/resource-page-new_year.png';
import newYearResourceWebp from '/img/bg/resource-page-new_year.webp';
import helloweenBackgroundPng from '/img/bg/WelcomeBack-helloween.png';
import helloweenBackgroundWebp from '/img/bg/WelcomeBack-helloween.webp';
import backgroundPng from '/img/bg/WellcomeBack.png';
import backgroundWebp from '/img/bg/WellcomeBack.webp';
import charactersPng from '/img/characters/characters.png';
import charactersWebp from '/img/characters/characters.webp';
import helloweenCharactersPng from '/img/characters/characters-helloween.png';
import helloweenCharactersWebp from '/img/characters/characters-helloween.webp';
import newYearCharactersPng from '/img/characters/characters-new_year.png';
import newYearCharactersWebp from '/img/characters/characters-new_year.webp';
import characterPng from '/img/characters/lumberjack-char-small.png';
import characterWebp from '/img/characters/lumberjack-char-small.webp';
import helloweenCharacterPng from '/img/characters/lumberjack-char-small-helloween.png';
import helloweenCharacterWebp from '/img/characters/lumberjack-char-small-helloween.webp';
import newYearCharacterPng from '/img/characters/lumberjack-char-small-new_year.png';
import newYearCharacterWebp from '/img/characters/lumberjack-char-small-new_year.webp';
import batsHelloween from '/img/first-screen/bats-helloween.png';
import candyNewYearPng from '/img/first-screen/candy-new_year.png';
import candyNewYearWebp from '/img/first-screen/candy-new_year.webp';
import cheersNewYearPng from '/img/first-screen/cheers-new_year.png';
import cheersNewYearWebp from '/img/first-screen/cheers-new_year.webp';
import newYearLightsNewYearPng from '/img/first-screen/new_year_lights-new_year.png';
import newYearLightsNewYearWebp from '/img/first-screen/new_year_lights-new_year.webp';
import poizonHelloween from '/img/first-screen/poizon-helloween.png';
import poizonHelloweenWebp from '/img/first-screen/poizon-helloween.webp';
import furniturePng from '/img/first-screen/products.png';
import furnitureWebp from '/img/first-screen/products.webp';
import helloweenFurniturePng from '/img/first-screen/products-helloween.png';
import helloweenFurnitureWebp from '/img/first-screen/products-helloween.webp';
import skullHelloween from '/img/first-screen/skull-helloween.png';
import sledNewyearPng from '/img/first-screen/sled-new_year.png';
import sledNewyearWebp from '/img/first-screen/sled-new_year.webp';
import toyPng from '/img/first-screen/soft-toys.png';
import toyWebp from '/img/first-screen/soft-toys.webp';
import trainPng from '/img/first-screen/trains.png';
import trainWebp from '/img/first-screen/trains.webp';
import helloweenTrainPng from '/img/first-screen/trains-helloween.png';
import helloweenTrainWebp from '/img/first-screen/trains-helloween.webp';
import treeToyNewYearPng from '/img/first-screen/tree_toy-new_year.png';
import treeToyNewYearWebp from '/img/first-screen/tree_toy-new_year.webp';
import webHelloween from '/img/first-screen/web-helloween.png';
import wreathNewYearPng from '/img/first-screen/wreath-new_year.png';
import wreathNewYearWebp from '/img/first-screen/wreath-new_year.webp';
import goodsBoardGames from '/img/icons/factory_icons/board_games.png';
import goodsBoardGamesHelloweenPng from '/img/icons/factory_icons/board_games-helloween.png';
import goodsBoardGamesHelloweenWebp from '/img/icons/factory_icons/board_games-helloween.webp';
import goodsBooks from '/img/icons/factory_icons/books.png';
import goodsBooksHelloween from '/img/icons/factory_icons/books-helloween.png';
import goodsBooksNewYear from '/img/icons/factory_icons/books-new_year.png';
import goodsCar from '/img/icons/factory_icons/car.png';
import goodsClothing from '/img/icons/factory_icons/clothing.png';
import goodsClothingHelloween from '/img/icons/factory_icons/clothing-helloween.png';
import goodsClothingNewYear from '/img/icons/factory_icons/clothing-new_year.png';
import goodsConstructionToys from '/img/icons/factory_icons/construction_toys.png';
import goodsElectricGuitar from '/img/icons/factory_icons/electric_guitar.png';
import goodsElectricGuitarHelloweenPng from '/img/icons/factory_icons/electric_guitar-helloween.png';
import goodsElectricGuitarHelloweenWebp from '/img/icons/factory_icons/electric_guitar-helloween.webp';
import goodsFootwear from '/img/icons/factory_icons/footwear.png';
import goodsFootwearHelloween from '/img/icons/factory_icons/footwear-helloween.png';
import goodsFootwearNewYear from '/img/icons/factory_icons/footwear-new_year.png';
import goodsFurniture from '/img/icons/factory_icons/furniture.png';
import goodsFurnitureHelloween from '/img/icons/factory_icons/furniture-helloween.png';
import goodsFurnitureHelloweenWebp from '/img/icons/factory_icons/furniture-helloween.webp';
import goodsFurnitureNewYear from '/img/icons/factory_icons/furniture-new_year.png';
import goodsGardenToolsPng from '/img/icons/factory_icons/garden_tools.png';
import goodsGardenToolsWebp from '/img/icons/factory_icons/garden_tools.webp';
import goodsGardenToolsHelloweenPng from '/img/icons/factory_icons/garden_tools-helloween.png';
import goodsGardenToolsHelloweenWebp from '/img/icons/factory_icons/garden_tools-helloween.webp';
import goodsGardenToolsNewYearPng from '/img/icons/factory_icons/garden_tools-new_year.png';
import goodsGardenToolsNewYearWebp from '/img/icons/factory_icons/garden_tools-new_year.webp';
import goodsGuitar from '/img/icons/factory_icons/guitar.png';
import goodsGuitarHelloween from '/img/icons/factory_icons/guitar-helloween.png';
import goodsGuitarNewYear from '/img/icons/factory_icons/guitar-new_year.png';
import goodsGuitarNewYearWebp from '/img/icons/factory_icons/guitar-new_year.webp';
import goodsHandTools from '/img/icons/factory_icons/hand_tools.png';
import goodsHandToolsHelloween from '/img/icons/factory_icons/hand_tools-helloween.png';
import goodsHandToolsNewYear from '/img/icons/factory_icons/hand_tools-new_year.png';
import goodsHomeTextiles from '/img/icons/factory_icons/home_textiles.png';
import goodsHomeTextilesHelloween from '/img/icons/factory_icons/home_textiles-helloween.png';
import goodsHomeTextilesNewYear from '/img/icons/factory_icons/home_textiles-new_year.png';
import goodsHomeTextilesNewYearWebp from '/img/icons/factory_icons/home_textiles-new_year.webp';
import goodsLamps from '/img/icons/factory_icons/lamps.png';
import goodsLampsHelloween from '/img/icons/factory_icons/lamps-helloween.png';
import goodsLampsNewYear from '/img/icons/factory_icons/lamps-new_year.png';
import goodsLampsNewYearWebp from '/img/icons/factory_icons/lamps-new_year.webp';
import goodsPackaging from '/img/icons/factory_icons/packaging.png';
import packagingHelloween from '/img/icons/factory_icons/packaging-helloween.png';
import packagingNewYear from '/img/icons/factory_icons/packaging-new_year.png';
import packagingNewYearWebp from '/img/icons/factory_icons/packaging-new_year.webp';
import goodsRobotics from '/img/icons/factory_icons/robotics.png';
import goodsSoftToys from '/img/icons/factory_icons/soft_toys.png';
import goodsSoftToysHelloween from '/img/icons/factory_icons/soft_toys-helloween.png';
import goodsSoftToysNewYear from '/img/icons/factory_icons/soft_toys-new_year.png';
import goodsSoftToysNewYearWebp from '/img/icons/factory_icons/soft_toys-new_year.webp';
import goodsUpholsteredFurniture from '/img/icons/factory_icons/upholstered_furniture.png';
import upholsteredFurnitureHelloween from '/img/icons/factory_icons/upholstered_furniture-helloween.png';
import upholsteredFurnitureNewYear from '/img/icons/factory_icons/upholstered_furniture-new_year.png';
import goodsVrEquipment from '/img/icons/factory_icons/vr_equipment.png';
import goodsWashingMachine from '/img/icons/factory_icons/washing_machine.png';
import goodsWashingMachineHelloweenPng from '/img/icons/factory_icons/washing_machine-helloween.png';
import goodsWashingMachineHelloweenWebp from '/img/icons/factory_icons/washing_machine-helloween.webp';
import arenaImagePng from '/img/img-arena.png';
import arenaImageWebp from '/img/img-arena.webp';
// import welcomeArenaPng from '/img/leagues/welcome-arena-usd.png';
// import welcomeArenaWebp from '/img/leagues/welcome-arena-usd.webp';
import helloweenWelcomeArenaPng from '/img/leagues/welcome-arena-usd-helloween.png';
import helloweenWelcomeArenaWebp from '/img/leagues/welcome-arena-usd-helloween.webp';
import contractPng from '/img/modals/claim-modal-bg.png';
import contractWebp from '/img/modals/claim-modal-bg.webp';
import helloweenContractPng from '/img/modals/claim-modal-bg-helloween.png';
import helloweenContractWebp from '/img/modals/claim-modal-bg-helloween.webp';
import newYearContractPng from '/img/modals/claim-modal-bg-new_year.png';
import newYearContractWebp from '/img/modals/claim-modal-bg-new_year.webp';
import welcomePng from '/img/onboarding/board-1.png';
import welcomeWebp from '/img/onboarding/board-1.webp';
import helloweenWelcomePng from '/img/onboarding/board-1-helloween.png';
import helloweenWelcomeWebp from '/img/onboarding/board-1-helloween.webp';
import newYearWelcomePng from '/img/onboarding/board-1-new_year.png';
import newYearWelcomeWebp from '/img/onboarding/board-1-new_year.webp';
import tonyPng from '/img/tony-default.png';
import tonyWebp from '/img/tony-default.webp';
import tonyNewYearPng from '/img/tony-default-new_year.png';
import tonyNewYearWebp from '/img/tony-default-new_year.webp';
import backgroundVipHomePng from '/img/VIP/main-page-vip.png';
import backgroundVipHomeWebp from '/img/VIP/main-page-vip.webp';
import helloweenBackgroundVipHomePng from '/img/VIP/main-page-vip-helloween.png';
import helloweenBackgroundVipHomeWebp from '/img/VIP/main-page-vip-helloween.webp';
import newYearBackgroundVipHomePng from '/img/VIP/main-page-vip-new_year.png';
import newYearBackgroundVipHomeWebp from '/img/VIP/main-page-vip-new_year.webp';
import tonyVipHelloweenPng from '/img/VIP/tony_vip_helloween.png';
import tonyVipHelloweenWebp from '/img/VIP/tony_vip_helloween.webp';
import tonyVipNewYearPng from '/img/VIP/tony_vip_new_year.png';
import tonyVipNewYearWebp from '/img/VIP/tony_vip_new_year.webp';

type HolidayBackground = {
  png: string;
  webp: string;
};

type HolidayPicture = {
  png: string;
  webp?: string;
};

interface HolidayBackgrounds {
  BG_WELCOME: HolidayBackground;
  BG_OFFICE: HolidayBackground;
  BG_OFFICE_VIP: HolidayBackground;
  BG_CONTRACT: HolidayBackground;
  BG_RESOURCE: HolidayBackground;
  BG_MATERIAL: HolidayBackground;
  BG_WOOD: HolidayBackground;
  BG_COTTON: HolidayBackground;
  BG_SAND: HolidayBackground;
  BG_IRON: HolidayBackground;
  BG_OIL: HolidayBackground;
  BG_GOLD: HolidayBackground;
  BG_RESOURCE_STOCK: HolidayBackground;
  BG_MATERIAL_STOCK: HolidayBackground;
  BG_GOODS_STOCK: HolidayBackground;
  BG_WELCOME_ARENA: HolidayBackground;
  BG_WELCOME_MODAL: HolidayBackground;

  BG_FACTORY_CHILDRENS?: HolidayBackground;
  BG_FACTORY_ELECTRONICS?: HolidayBackground;
  BG_FACTORY_FURNITURE?: HolidayBackground;
  BG_FACTORY_GARMENT?: HolidayBackground;
  BG_FACTORY_HOMEWARE?: HolidayBackground;
  BG_FACTORY_MECHANIC?: HolidayBackground;
  BG_FACTORY_MUSIC?: HolidayBackground;
  BG_FACTORY_PRINTED?: HolidayBackground;
  BG_FACTORY_TOOLMAKING?: HolidayBackground;
}

interface RiveAnimations {
  VIP_TONY: string;
  TONY: string;
}

interface HolidayPictures {
  FIRST_LOAD_CHARACTERS: HolidayPicture;
  FIRST_SCREEN_ITEM_1: HolidayPicture;
  FIRST_SCREEN_ITEM_2: HolidayPicture;
  FIRST_SCREEN_ITEM_3: HolidayPicture;
  FIRST_SCREEN_ITEM_4: HolidayPicture;
  FIRST_SCREEN_ITEM_5: HolidayPicture;
  FIRST_SCREEN_ITEM_6: HolidayPicture;
  FIRST_SCREEN_ITEM_7: HolidayPicture;
  FIRST_SCREEN_ITEM_8: HolidayPicture;
  FIRST_SCREEN_ITEM_9: HolidayPicture;
  FIRST_SCREEN_ITEM_10: HolidayPicture;
  FIRST_SCREEN_ITEM_11: HolidayPicture;
  FIRST_SCREEN_ITEM_12: HolidayPicture;
  FIRST_SCREEN_ITEM_13: HolidayPicture;
  FURNITURE_ICON: HolidayPicture;
  SOFT_TOYS_ICON: HolidayPicture;
  GARDEN_TOOLS_ICON: HolidayPicture;
  LAMPS_ICON: HolidayPicture;
  BOOKS_ICON: HolidayPicture;
  PACKAGING_ICON: HolidayPicture;
  UPHOLSTERED_FURNITURE_ICON: HolidayPicture;
  CLOTHING_ICON: HolidayPicture;
  FOOTWEAR_ICON: HolidayPicture;
  HOME_TEXTILES_ICON: HolidayPicture;
  HAND_TOOLS_ICON: HolidayPicture;
  GUITAR_ICON: HolidayPicture;
  BOARD_GAMES_ICON: HolidayPicture;
  ELECTRIC_GUITAR_ICON: HolidayPicture;
  WASHING_MACHINE_ICON: HolidayPicture;
  LUMBERJACK_CHAR_SMALL: HolidayPicture;

  // Rive fallbacks
  TONY: HolidayPicture;
  TONY_VIP?: HolidayPicture;
}

type HolidayType = 'helloween' | 'default' | 'new_year';

// Only `default` must be complete; holidays override what was redrawn
type HolidayConfig<T> = { default: T } & Partial<
  Record<Exclude<HolidayType, 'default'>, Partial<T>>
>;

const PICTURES_HOLIDAY_CONFIG: HolidayConfig<HolidayPictures> = {
  default: {
    FIRST_LOAD_CHARACTERS: {
      png: charactersPng,
      webp: charactersWebp,
    },
    FIRST_SCREEN_ITEM_1: {
      png: furniturePng,
      webp: furnitureWebp,
    },
    FIRST_SCREEN_ITEM_2: {
      png: toyPng,
      webp: toyWebp,
    },
    FIRST_SCREEN_ITEM_3: {
      png: trainPng,
      webp: trainWebp,
    },
    FIRST_SCREEN_ITEM_4: {
      png: goodsHomeTextiles,
    },
    FIRST_SCREEN_ITEM_5: {
      png: goodsFootwear,
    },
    FIRST_SCREEN_ITEM_6: {
      png: goodsClothing,
    },
    FIRST_SCREEN_ITEM_7: {
      png: goodsCar,
    },
    FIRST_SCREEN_ITEM_8: {
      png: goodsGuitar,
    },
    FIRST_SCREEN_ITEM_9: {
      png: goodsRobotics,
    },
    FIRST_SCREEN_ITEM_10: {
      png: goodsVrEquipment,
    },
    FIRST_SCREEN_ITEM_11: {
      png: goodsConstructionToys,
    },
    FIRST_SCREEN_ITEM_12: {
      png: goodsBooks,
    },
    FIRST_SCREEN_ITEM_13: {
      png: goodsBooks,
    },
    FURNITURE_ICON: {
      png: goodsFurniture,
    },
    SOFT_TOYS_ICON: {
      png: goodsSoftToys,
    },
    LAMPS_ICON: {
      png: goodsLamps,
    },
    BOOKS_ICON: {
      png: goodsBooks,
    },
    PACKAGING_ICON: {
      png: goodsPackaging,
    },
    UPHOLSTERED_FURNITURE_ICON: {
      png: goodsUpholsteredFurniture,
    },
    CLOTHING_ICON: {
      png: goodsClothing,
    },
    FOOTWEAR_ICON: {
      png: goodsFootwear,
    },
    HOME_TEXTILES_ICON: {
      png: goodsHomeTextiles,
    },
    HAND_TOOLS_ICON: {
      png: goodsHandTools,
    },
    GUITAR_ICON: {
      png: goodsGuitar,
    },
    GARDEN_TOOLS_ICON: {
      png: goodsGardenToolsPng,
      webp: goodsGardenToolsWebp,
    },
    BOARD_GAMES_ICON: {
      png: goodsBoardGames,
    },
    ELECTRIC_GUITAR_ICON: {
      png: goodsElectricGuitar,
    },
    WASHING_MACHINE_ICON: {
      png: goodsWashingMachine,
    },
    LUMBERJACK_CHAR_SMALL: {
      png: characterPng,
      webp: characterWebp,
    },
    TONY: {
      png: tonyPng,
      webp: tonyWebp,
    },
  },
  helloween: {
    FIRST_LOAD_CHARACTERS: {
      png: helloweenCharactersPng,
      webp: helloweenCharactersWebp,
    },
    FIRST_SCREEN_ITEM_1: {
      png: helloweenFurniturePng,
      webp: helloweenFurnitureWebp,
    },
    FIRST_SCREEN_ITEM_2: {
      png: goodsFurnitureHelloween,
      webp: goodsFurnitureHelloweenWebp,
    },
    FIRST_SCREEN_ITEM_3: {
      png: helloweenTrainPng,
      webp: helloweenTrainWebp,
    },
    FIRST_SCREEN_ITEM_4: {
      png: poizonHelloween,
      webp: poizonHelloweenWebp,
    },
    FIRST_SCREEN_ITEM_5: {
      png: goodsSoftToysHelloween,
    },
    FIRST_SCREEN_ITEM_6: {
      png: goodsLampsHelloween,
    },
    FIRST_SCREEN_ITEM_7: {
      png: webHelloween,
    },
    FIRST_SCREEN_ITEM_8: {
      png: goodsHomeTextilesHelloween,
    },
    FIRST_SCREEN_ITEM_9: {
      png: packagingHelloween,
    },
    FIRST_SCREEN_ITEM_10: {
      png: goodsBooksHelloween,
    },
    FIRST_SCREEN_ITEM_11: {
      png: goodsFootwearHelloween,
    },
    FIRST_SCREEN_ITEM_12: {
      png: batsHelloween,
    },
    FIRST_SCREEN_ITEM_13: {
      png: skullHelloween,
    },
    FURNITURE_ICON: {
      png: goodsFurnitureHelloween,
    },
    SOFT_TOYS_ICON: {
      png: goodsSoftToysHelloween,
    },
    LAMPS_ICON: {
      png: goodsLampsHelloween,
    },
    BOOKS_ICON: {
      png: goodsBooksHelloween,
    },
    PACKAGING_ICON: {
      png: packagingHelloween,
    },
    UPHOLSTERED_FURNITURE_ICON: {
      png: upholsteredFurnitureHelloween,
    },
    CLOTHING_ICON: {
      png: goodsClothingHelloween,
    },
    FOOTWEAR_ICON: {
      png: goodsFootwearHelloween,
    },
    HOME_TEXTILES_ICON: {
      png: goodsHomeTextilesHelloween,
    },
    HAND_TOOLS_ICON: {
      png: goodsHandToolsHelloween,
    },
    GUITAR_ICON: {
      png: goodsGuitarHelloween,
    },
    GARDEN_TOOLS_ICON: {
      png: goodsGardenToolsHelloweenPng,
      webp: goodsGardenToolsHelloweenWebp,
    },
    BOARD_GAMES_ICON: {
      png: goodsBoardGamesHelloweenPng,
      webp: goodsBoardGamesHelloweenWebp,
    },
    ELECTRIC_GUITAR_ICON: {
      png: goodsElectricGuitarHelloweenPng,
      webp: goodsElectricGuitarHelloweenWebp,
    },
    WASHING_MACHINE_ICON: {
      png: goodsWashingMachineHelloweenPng,
      webp: goodsWashingMachineHelloweenWebp,
    },
    LUMBERJACK_CHAR_SMALL: {
      png: helloweenCharacterPng,
      webp: helloweenCharacterWebp,
    },
    TONY_VIP: {
      png: tonyVipHelloweenPng,
      webp: tonyVipHelloweenWebp,
    },
    TONY: {
      png: tonyPng,
      webp: tonyWebp,
    },
  },
  new_year: {
    FIRST_LOAD_CHARACTERS: {
      png: newYearCharactersPng,
      webp: newYearCharactersWebp,
    },
    FIRST_SCREEN_ITEM_1: {
      png: packagingNewYear,
      webp: packagingNewYearWebp,
    },
    FIRST_SCREEN_ITEM_2: {
      png: goodsSoftToysNewYear,
      webp: goodsSoftToysNewYearWebp,
    },
    FIRST_SCREEN_ITEM_3: {
      png: goodsLampsNewYear,
      webp: goodsLampsNewYearWebp,
    },
    FIRST_SCREEN_ITEM_4: {
      png: goodsHomeTextilesNewYear,
      webp: goodsHomeTextilesNewYearWebp,
    },
    FIRST_SCREEN_ITEM_5: {
      png: goodsClothingNewYear,
    },
    FIRST_SCREEN_ITEM_6: {
      png: treeToyNewYearPng,
      webp: treeToyNewYearWebp,
    },
    FIRST_SCREEN_ITEM_7: {
      png: candyNewYearPng,
      webp: candyNewYearWebp,
    },
    FIRST_SCREEN_ITEM_8: {
      png: newYearLightsNewYearPng,
      webp: newYearLightsNewYearWebp,
    },
    FIRST_SCREEN_ITEM_9: {
      png: cheersNewYearPng,
      webp: cheersNewYearWebp,
    },
    FIRST_SCREEN_ITEM_10: {
      png: sledNewyearPng,
      webp: sledNewyearWebp,
    },
    FIRST_SCREEN_ITEM_11: {
      png: goodsBooksNewYear,
    },
    FIRST_SCREEN_ITEM_12: {
      png: wreathNewYearPng,
      webp: wreathNewYearWebp,
    },
    FIRST_SCREEN_ITEM_13: {
      png: goodsGuitarNewYear,
      webp: goodsGuitarNewYearWebp,
    },
    FURNITURE_ICON: {
      png: goodsFurnitureNewYear,
    },
    SOFT_TOYS_ICON: {
      png: goodsSoftToysNewYear,
    },
    LAMPS_ICON: {
      png: goodsLampsNewYear,
    },
    BOOKS_ICON: {
      png: goodsBooksNewYear,
    },
    PACKAGING_ICON: {
      png: packagingNewYear,
    },
    UPHOLSTERED_FURNITURE_ICON: {
      png: upholsteredFurnitureNewYear,
    },
    CLOTHING_ICON: {
      png: goodsClothingNewYear,
    },
    FOOTWEAR_ICON: {
      png: goodsFootwearNewYear,
    },
    HOME_TEXTILES_ICON: {
      png: goodsHomeTextilesNewYear,
    },
    HAND_TOOLS_ICON: {
      png: goodsHandToolsNewYear,
    },
    GUITAR_ICON: {
      png: goodsGuitarNewYear,
    },
    GARDEN_TOOLS_ICON: {
      png: goodsGardenToolsNewYearPng,
      webp: goodsGardenToolsNewYearWebp,
    },
    LUMBERJACK_CHAR_SMALL: {
      png: newYearCharacterPng,
      webp: newYearCharacterWebp,
    },
    TONY_VIP: {
      png: tonyVipNewYearPng,
      webp: tonyVipNewYearWebp,
    },
    TONY: {
      png: tonyNewYearPng,
      webp: tonyNewYearWebp,
    },
  },
};

export const BACKGROUND_HOLIDAY_CONFIG: HolidayConfig<HolidayBackgrounds> = {
  default: {
    BG_WELCOME: {
      png: welcomePng,
      webp: welcomeWebp,
    },
    BG_OFFICE_VIP: {
      png: backgroundVipHomePng,
      webp: backgroundVipHomeWebp,
    },
    BG_OFFICE: {
      png: backgroundHomePng,
      webp: backgroundHomeWebp,
    },
    BG_CONTRACT: {
      png: contractPng,
      webp: contractWebp,
    },
    BG_RESOURCE: {
      png: resourcePng,
      webp: resourceWebp,
    },
    BG_MATERIAL: {
      png: materialPng,
      webp: materialWebp,
    },
    BG_WOOD: {
      png: backgroundWoodJpg,
      webp: backgroundWoodWebp,
    },
    BG_COTTON: {
      png: backgroundCottonJpg,
      webp: backgroundCottonWebp,
    },
    BG_SAND: {
      png: backgroundSandJpg,
      webp: backgroundSandWebp,
    },
    BG_IRON: {
      png: backgroundIronJpg,
      webp: backgroundIronWebp,
    },
    BG_OIL: {
      png: backgroundOilJpg,
      webp: backgroundOilWebp,
    },
    BG_GOLD: {
      png: backgroundPreciousJpg,
      webp: backgroundPreciousWebp,
    },
    BG_GOODS_STOCK: {
      png: backgroundGoodsStockPng,
      webp: backgroundGoodsStockWebp,
    },
    BG_MATERIAL_STOCK: {
      png: backgroundMaterialStockPng,
      webp: backgroundMaterialStockWebp,
    },
    BG_RESOURCE_STOCK: {
      png: backgroundResourceStockPng,
      webp: backgroundResourceStockWebp,
    },
    BG_WELCOME_ARENA: {
      png: arenaImagePng,
      webp: arenaImageWebp,
    },
    BG_WELCOME_MODAL: {
      png: backgroundPng,
      webp: backgroundWebp,
    },
    BG_FACTORY_CHILDRENS: {
      png: backgroundFactoryChildrenJpg,
      webp: backgroundFactoryChildrenWebp,
    },
    BG_FACTORY_ELECTRONICS: {
      png: backgroundFactoryElectronicsJpg,
      webp: backgroundFactoryElectronicsWebp,
    },
    BG_FACTORY_FURNITURE: {
      png: backgroundFactoryFurnitureJpg,
      webp: backgroundFactoryFurnitureWebp,
    },
    BG_FACTORY_GARMENT: {
      png: backgroundFactoryGarmentJpg,
      webp: backgroundFactoryGarmentWebp,
    },
    BG_FACTORY_HOMEWARE: {
      png: backgroundFactoryHomewareJpg,
      webp: backgroundFactoryHomewareWebp,
    },
    BG_FACTORY_MECHANIC: {
      png: backgroundFactoryMechanicJpg,
      webp: backgroundFactoryMechanicWebp,
    },
    BG_FACTORY_MUSIC: {
      png: backgroundFactoryMusicJpg,
      webp: backgroundFactoryMusicWebp,
    },
    BG_FACTORY_PRINTED: {
      png: backgroundFactoryPrintedJpg,
      webp: backgroundFactoryPrintedWebp,
    },
    BG_FACTORY_TOOLMAKING: {
      png: backgroundFactoryToolmakingJpg,
      webp: backgroundFactoryToolmakingWebp,
    },
  },
  helloween: {
    BG_WELCOME: {
      png: helloweenWelcomePng,
      webp: helloweenWelcomeWebp,
    },
    BG_OFFICE_VIP: {
      png: helloweenBackgroundVipHomePng,
      webp: helloweenBackgroundVipHomeWebp,
    },
    BG_OFFICE: {
      png: helloweenBackgroundHomePng,
      webp: helloweenBackgroundHomeWebp,
    },
    BG_CONTRACT: {
      png: helloweenContractPng,
      webp: helloweenContractWebp,
    },
    BG_RESOURCE: {
      png: helloweenResourcePng,
      webp: helloweenResourceWebp,
    },
    BG_MATERIAL: {
      png: helloweenMaterialPng,
      webp: helloweenMaterialWebp,
    },
    BG_WOOD: {
      png: helloweenBackgroundWoodPng,
      webp: helloweenBackgroundWoodWebp,
    },
    BG_COTTON: {
      png: helloweenBackgroundCottonPng,
      webp: helloweenBackgroundCottonWebp,
    },
    BG_SAND: {
      png: helloweenBackgroundSandPng,
      webp: helloweenBackgroundSandWebp,
    },
    BG_IRON: {
      png: helloweenBackgroundIronPng,
      webp: helloweenBackgroundIronWebp,
    },
    BG_OIL: {
      png: helloweenBackgroundOilPng,
      webp: helloweenBackgroundOilWebp,
    },
    BG_GOLD: {
      png: helloweenBackgroundPreciousPng,
      webp: helloweenBackgroundPreciousWebp,
    },
    BG_RESOURCE_STOCK: {
      png: helloweenBackgroundResourceStockPng,
      webp: helloweenBackgroundResourceStockWebp,
    },
    BG_MATERIAL_STOCK: {
      png: helloweenBackgroundMaterialStockPng,
      webp: helloweenBackgroundMaterialStockWebp,
    },
    BG_GOODS_STOCK: {
      png: helloweenBackgroundGoodsStockPng,
      webp: helloweenBackgroundGoodsStockWebp,
    },
    BG_WELCOME_ARENA: {
      png: helloweenWelcomeArenaPng,
      webp: helloweenWelcomeArenaWebp,
    },
    BG_WELCOME_MODAL: {
      png: helloweenBackgroundPng,
      webp: helloweenBackgroundWebp,
    },
  },
  new_year: {
    BG_WELCOME: {
      png: newYearWelcomePng,
      webp: newYearWelcomeWebp,
    },
    BG_OFFICE_VIP: {
      png: newYearBackgroundVipHomePng,
      webp: newYearBackgroundVipHomeWebp,
    },
    BG_OFFICE: {
      png: newYearBackgroundHomePng,
      webp: newYearBackgroundHomeWebp,
    },
    BG_CONTRACT: {
      png: newYearContractPng,
      webp: newYearContractWebp,
    },
    BG_RESOURCE: {
      png: newYearResourcePng,
      webp: newYearResourceWebp,
    },
    BG_MATERIAL: {
      png: newYearMaterialPng,
      webp: newYearMaterialWebp,
    },
    BG_WOOD: {
      png: newYearBackgroundWoodPng,
      webp: newYearBackgroundWoodWebp,
    },
    BG_COTTON: {
      png: newYearBackgroundCottonPng,
      webp: newYearBackgroundCottonWebp,
    },
    BG_SAND: {
      png: newYearBackgroundSandPng,
      webp: newYearBackgroundSandWebp,
    },
    BG_IRON: {
      png: newYearBackgroundIronPng,
      webp: newYearBackgroundIronWebp,
    },
    BG_OIL: {
      png: newYearBackgroundOilPng,
      webp: newYearBackgroundOilWebp,
    },
    BG_GOLD: {
      png: newYearBackgroundPreciousPng,
      webp: newYearBackgroundPreciousWebp,
    },
    BG_RESOURCE_STOCK: {
      png: newYearBackgroundResourceStockPng,
      webp: newYearBackgroundResourceStockWebp,
    },
    BG_MATERIAL_STOCK: {
      png: newYearBackgroundMaterialStockPng,
      webp: newYearBackgroundMaterialStockWebp,
    },
    BG_GOODS_STOCK: {
      png: newYearBackgroundGoodsStockPng,
      webp: newYearBackgroundGoodsStockWebp,
    },
    BG_WELCOME_ARENA: {
      png: arenaImagePng,
      webp: arenaImageWebp,
    },
    BG_WELCOME_MODAL: {
      png: backgroundPng,
      webp: backgroundWebp,
    },
    BG_FACTORY_CHILDRENS: {
      png: newYearBackgroundFactoryChildrenPng,
      webp: newYearBackgroundFactoryChildrenWebp,
    },
    BG_FACTORY_ELECTRONICS: {
      png: newYearBackgroundFactoryElectronicsPng,
      webp: newYearBackgroundFactoryElectronicsWebp,
    },
    BG_FACTORY_FURNITURE: {
      png: newYearBackgroundFactoryFurniturePng,
      webp: newYearBackgroundFactoryFurnitureWebp,
    },
    BG_FACTORY_GARMENT: {
      png: newYearBackgroundFactoryGarmentPng,
      webp: newYearBackgroundFactoryGarmentWebp,
    },
    BG_FACTORY_HOMEWARE: {
      png: newYearBackgroundFactoryHomewarePng,
      webp: newYearBackgroundFactoryHomewareWebp,
    },
    BG_FACTORY_MUSIC: {
      png: newYearBackgroundFactoryMusicPng,
      webp: newYearBackgroundFactoryMusicWebp,
    },
    BG_FACTORY_PRINTED: {
      png: newYearBackgroundFactoryPrintedPng,
      webp: newYearBackgroundFactoryPrintedWebp,
    },
    BG_FACTORY_TOOLMAKING: {
      png: newYearBackgroundFactoryToolmakingPng,
      webp: newYearBackgroundFactoryToolmakingWebp,
    },
  },
};
export const RIVE_HOLIDAY_CONFIG: Partial<Record<HolidayType, RiveAnimations>> =
  {
    default: {
      VIP_TONY: vipRive,
      TONY: tonyRive,
    },
  };
// Unknown VITE_HOLIDAY values (typos etc.) fall back to the default theme
const envHoliday = import.meta.env.VITE_HOLIDAY as HolidayType | undefined;

export const HOLIDAY_KEY: HolidayType =
  envHoliday && envHoliday in PICTURES_HOLIDAY_CONFIG ? envHoliday : 'default';
export const RIVE_CONFIG = RIVE_HOLIDAY_CONFIG[HOLIDAY_KEY];
// Holiday configs only list what was redrawn; anything missing uses default art
export const BACKGROUNDS_CONFIG: HolidayBackgrounds = {
  ...BACKGROUND_HOLIDAY_CONFIG.default,
  ...BACKGROUND_HOLIDAY_CONFIG[HOLIDAY_KEY],
};
export const PICTURES_CONFIG: HolidayPictures = {
  ...PICTURES_HOLIDAY_CONFIG.default,
  ...PICTURES_HOLIDAY_CONFIG[HOLIDAY_KEY],
};
